import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ApplicationForm from './ApplicationForm'; 
import NewsletterSignup from "./NewsletterSignup";
import { logout } from '../../redux/actions/authActions';

const VitalDHome = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName, setUserName] = useState(authState.user.name);
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/legend");
  };

  return (
    <div className="font-sans text-gray-800 bg-gray-100">
      {/* Header */}
      <header className="flex justify-between items-center px-6 py-4 bg-green-600 shadow-md sticky top-0 z-50">
        <div className="text-3xl font-extrabold text-yellow-200 tracking-wide">VITAL-D</div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6 font-medium text-gray-700">
          <a href="#courses" className="text-white hover:text-yellow-200 transition">Courses</a>
          <a href="#faculty" className="text-white hover:text-yellow-200 transition">Faculty</a>
          <a href="#whyus" className="text-white hover:text-yellow-200 transition">Why Us</a>
          <a href="/legend-updates" className="text-white hover:text-yellow-200 transition">Updates</a>
        </nav>

        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn ? (
            <>
              <span className="text-yellow-200 font-medium">Welcome, {userName}</span>
              <button
                onClick={() => navigate(`/legenddashboard`)}
                className="w-9 h-9 flex items-center justify-center text-lg bg-green-500 text-white rounded-full hover:bg-green-600 transition"
                title="Dashboard"
              >
                🏠
              </button>
              <button
                onClick={handleLogout}
                className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm border border-blue-500 text-blue-600 rounded-full hover:bg-blue-50 transition"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-4 py-2 text-sm bg-blue-600 text-white rounded-full hover:bg-blue-700 transition"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile Hamburger */}
        <div className="md:hidden flex items-center justify-center w-24">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-3xl text-blue-600 focus:outline-none"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white px-6 py-4 space-y-1 text-center shadow-md">
          {isLoggedIn && (
            <div className="flex flex-col items-center text-gray-800">
              <p className="text-green-600 font-medium">Welcome, {userName}</p>
              <div className="flex space-x-4 mt-2">
                <button
                  onClick={() => navigate(`/legenddashboard`)}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-green-500 text-white rounded-full hover:bg-green-600 transition"
                >
                  🏠
                </button>
                <button
                  onClick={handleLogout}
                  className="w-10 h-10 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition"
                >
                  ⏻
                </button>
              </div>
            </div>
          )}
          <a href="#courses" className="block hover:text-yellow-200">Courses</a>
          <a href="#faculty" className="block hover:text-yellow-200">Faculty</a>
          <a href="#whyus" className="block hover:text-yellow-200">Why Us</a>
          <a href="/legend-updates" className="block hover:text-yellow-200">Updates</a>

          {!isLoggedIn && (
            <div className="flex justify-center space-x-4 pt-2">
              <button className="px-4 py-2 text-sm border border-blue-500 text-blue-600 rounded-full hover:bg-blue-50 transition">Login</button>
              <button className="px-4 py-2 text-sm bg-blue-600 text-white rounded-full hover:bg-blue-700 transition">Register</button>
            </div>
          )}
        </div>
      )}

      {/* Hero Section */}
      <section
        className="relative h-[75vh] sm:h-[85vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: "url('/assets/banners/vitald.webp')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        <div className="relative z-10 text-center px-4 sm:px-6 max-w-2xl">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4 leading-tight">
            VITAL-D
          </h1>
          <p className="text-lg mb-6 font-light">VITAL-D is a Digital School for - Versatile Intelligent Training for Adaptive Learning for Doctors</p>
          <a href="#vision" className="block">
            <button
              className="px-6 py-3 text-lg font-semibold bg-blue-600 rounded-full hover:bg-blue-700 transition hover:text-yellow-200"
            >
              Mission, Vision & Values
            </button>
          </a>
        </div>
      </section>

      {/* Courses Section */}
      <section id="courses" className="py-16 px-6 md:px-20 bg-gray-100">
        <h2 className="text-3xl font-bold text-center mb-10 text-blue-700">Courses</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              id: 1,
              title: "Digital Law & Legal Technology",
              description: "Learn cyber law, legal tech tools, digital evidence & automation.",
              img: "/api/downloads/thinkdscut/legend/courses/digital-law.jpg"
            },
            {
              id: 2,
              title: "Think5Whys Legal Reasoning Program",
              description: "Master critical thinking, case analysis, and strategic legal decision-making.",
              img: "/api/downloads/thinkdscut/legend/courses/legal-reasoning.jpg"
            },
            {
              id: 3,
              title: "CLE+ for Modern Legal Practice",
              description: "Modular credits in ADR, IP, ESG, and legal project management.",
              img: "/api/downloads/thinkdscut/legend/courses/cle-plus.jpg"
            }
          ].map((course) => (
            <div key={course.id} className="bg-white shadow-md hover:shadow-xl transition rounded-xl overflow-hidden">
              <img 
                src={course.img} 
                alt={course.title} 
                className="w-full h-52 object-cover"
              />
              <div className="p-5">
                <h3 className="text-xl font-semibold text-gray-800">{course.title}</h3>
                <p className="text-gray-600 mt-2">{course.description}</p>
                <button 
                  onClick={() => navigate(`/courses/${course.id}`)}
                  className="mt-4 px-5 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 text-sm transition">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section id="faculty" className="py-16 px-6 md:px-20 bg-gray-100">
        <h2 className="text-3xl font-bold text-center mb-10 text-blue-700">Faculty</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              id: 1,
              name: "Ajay Srivastava",
              title: "Veteran Legal Counsel, Advocate, Supreme Court of India",
              img: "/api/downloads/thinkdscut/legend/faculty/nofacultyimage.jpg"
            },
            {
              id: 2,
              name: "Sanjeev Kumar",
              title: "Digital, AI & Cybersecurity Expert, Founder Think5Whys Global DeepTech Solutions",
              img: "/api/downloads/thinkdscut/legend/faculty/nofacultyimage.jpg"
            },
            {
              id: 3,
              name: "U. Swaminathan",
              title: "Cyberlaw Expert, Advocate, Madras High Court",
              img: "/api/downloads/thinkdscut/legend/faculty/nofacultyimage.jpg"
            }
          ].map((faculty) => (
            <div key={faculty.id} className="bg-white shadow-md hover:shadow-xl transition rounded-xl overflow-hidden text-center">
              <div className="flex justify-center items-center h-52 bg-gray-100">
                <img 
                  src={faculty.img} 
                  alt={faculty.name} 
                  className="h-full object-contain"
                />
              </div>
              <div className="p-5">
                <h3 className="text-xl font-semibold text-gray-800">{faculty.name}</h3>
                <p className="text-gray-600 mt-2">{faculty.title}</p>
              </div>
              <div className="p-5">
                <h3 className="text-xl font-semibold text-gray-800">{faculty.name}</h3>
                <p className="text-gray-600 mt-2">{faculty.title}</p>
              </div>
            </div>
          ))}
        </div>
      </section>


      {/* Why Choose LEGEND */}
      <section id="whyus" className="py-16 px-6 md:px-20 bg-gradient-to-r from-indigo-800 to-purple-600">
        <h2 className="text-3xl font-bold text-center mb-10 text-white">Why LEGEND?</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 text-center text-white">
          {[
            {
              title: "Digital Legal University",
              emoji: "🎓",
              desc: "A future-ready platform offering legal education and CLE in a modern, accessible format."
            },
            {
              title: "Expert-Led Courses",
              emoji: "🧑‍⚖️",
              desc: "Learn from leading lawyers, judges, and industry veterans across disciplines."
            },
            {
              title: "Think5Whys Integration",
              emoji: "🧠",
              desc: "Boost critical thinking with our proprietary Think5Whys analysis and decision tools."
            },
            {
              title: "CLE Certifications",
              emoji: "📜",
              desc: "Earn continuing legal education credits to stay compliant and competitive."
            },
            {
              title: "On-Demand Learning",
              emoji: "🕒",
              desc: "Study anytime, anywhere — designed for busy professionals and law students alike."
            },
            {
              title: "AI-Driven Legal Tools",
              emoji: "🤖",
              desc: "Get access to smart legal research assistants and learning recommendations."
            },
            {
              title: "Simulated Legal Practice",
              emoji: "⚖️",
              desc: "Engage in mock trials, case simulations, and debate forums within a digital courtroom."
            },
            {
              title: "Secure Knowledge Hub",
              emoji: "🔐",
              desc: "Access digitized judgments, acts, and curated resources in a safe, structured library."
            },
            {
              title: "Ally-Driven Expansion",
              emoji: "🤝",
              desc: "Join a movement backed by legal visionaries and institutions across India."
            }
          ].map((feature, idx) => (
            <div key={idx} className="bg-white/10 p-6 rounded-lg shadow-md backdrop-blur-md hover:bg-white/20 transition">
              <div className="text-5xl mb-4">{feature.emoji}</div>
              <h4 className="text-xl font-semibold mb-2">{feature.title}</h4>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Vision, Mission & Values */}
      <section id="vision" className="py-16 px-6 md:px-20 bg-gradient-to-r from-green-800 to-blue-600 text-white">
        <h2 className="text-2xl font-bold text-center mb-10">Vision, Mission & Values</h2>
        
        <div className="max-w-5xl mx-auto space-y-10">
          {/* Vision */}
          <div className="bg-white/10 p-6 rounded-lg shadow-md backdrop-blur-md hover:bg-white/20 transition">
            <h3 className="text-xl font-semibold mb-2">🌟 Vision</h3>
            <p className="text-lg">
              To become the premier Digital Law University that redefines legal education through continuous learning,
              innovation, and deep thinking, empowering legal professionals to thrive in a dynamic and digitally-driven world.
            </p>
          </div>

          {/* Mission */}
          <div className="bg-white/10 p-6 rounded-lg shadow-md backdrop-blur-md hover:bg-white/20 transition">
            <h3 className="text-xl font-semibold mb-2">🎯 Mission</h3>
            <ul className="list-disc list-inside text-lg space-y-2">
              <li>To democratize access to high-quality legal education and Continuous Legal Education (CLE).</li>
              <li>To integrate critical thinking frameworks like <strong>Think5Whys</strong> into legal pedagogy.</li>
              <li>To build strategic alliances with legal experts, institutions, and technologists.</li>
              <li>To nurture a global community of legal minds committed to lifelong learning, ethics, and digital innovation.</li>
            </ul>
          </div>

          {/* Core Values */}
          <div className="bg-white/10 p-6 rounded-lg shadow-md backdrop-blur-md hover:bg-white/20 transition">
            <h3 className="text-xl font-semibold mb-2">💡 Core Values</h3>
            <ul className="list-disc list-inside text-lg space-y-2">
              <li><strong>Integrity & Ethics</strong> — Upholding truth, fairness, and justice.</li>
              <li><strong>Innovation</strong> — Driving digital transformation in legal education.</li>
              <li><strong>Inclusivity</strong> — Making legal knowledge accessible for all.</li>
              <li><strong>Excellence</strong> — Delivering high-quality and relevant learning outcomes.</li>
              <li><strong>Collaboration</strong> — Building bridges between academia, practitioners, and technologists.</li>
              <li><strong>Critical Inquiry</strong> — Empowering deeper problem-solving and analytical thinking.</li>
            </ul>
          </div>
        </div>
      </section>


      {/* More Sections like Agent Join / Newsletter Signup / Testimonials can be added here */}
      <NewsletterSignup />

      {/* Footer */}
      <footer className="bg-green-600 text-white py-10 px-4 sm:px-6 md:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-400 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-400 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-400 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-400 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VitalDHome;
